/**
 * Test IDs for QA automation.
 */
export const testIds = {
  documentsListOpenDocument: "documents-list-open-document",
} as const;
